import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockIcon from "@mui/icons-material/Lock";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import Typography from "@mui/material/Typography";
import imgLogin from "./images/aactmn17.png";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import loginImg from "./images/LogIn2.gif";

const defaultTheme = createTheme();

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useNavigate();
  const apiUrl = process.env.REACT_APP_API;
  const apiUrl2 = process.env.REACT_APP_APITEST;

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const loginBtn = async () => {
    const name = username;
    const pw = password;
    fetch(`${apiUrl}/user/asign?name=${name}&pw=${pw}`)
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setUsername("");
        setPassword("");
        if (res.length > 0) {
          sessionStorage.setItem("id", res[0].userId);
          sessionStorage.setItem("authority", res[0].userCrAdmin);
          sessionStorage.setItem("sams", res[0].userSamsAdmin);
          sessionStorage.setItem("sq", res[0].userSqAdmin);
          sessionStorage.setItem("it", res[0].userItAdmin);
          if (sessionStorage.getItem("sq") === "Y") {
            if (sessionStorage.getItem("it") === "Y") {
              history("/edi/livelist");
            }
            if (sessionStorage.getItem("id") === "cxair") {
              sessionStorage.setItem(
                "carrierCode",
                res[0].userId.substring(0, 2)
              );

              history("/sq/holdlist");
            }
            if (sessionStorage.getItem("id") === "acair") {
              sessionStorage.setItem(
                "carrierCode",
                res[0].userId.substring(0, 2)
              );
              history("/sq/holdlist");
            }
            if (sessionStorage.getItem("id") === "sqair") {
              sessionStorage.setItem(
                "carrierCode",
                res[0].userId.substring(0, 2)
              );
              history("/sq/holdlist");
            }
          } else {
            history("/reservation");
          }
        } else {
          alert("로그인 실패");
        }
      })
      .catch((error) => {
        alert("로그인실패" + error);
        setUsername("");
        setPassword("");
      });
  };

  const [pdfUrl, setPdfUrl] = useState(null);
  const test = async () => {
    try {
      // 서버에 다운로드 요청을 보냅니다.
      const response = await fetch(`${apiUrl2}/eawb/mawb`, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      });
      // PDF 다운로드 링크 생성
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (error) {
      console.error("다운로드 중 에러 발생:", error);
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          height: "100vh",
          backgroundColor: "#16253A",
        }}
      >
        <img
          src={imgLogin}
          style={{ maxHeight: "100vh", objectFit: "cover" }}
        />
        <Box>
          <img
            src={loginImg}
            style={{ display: windowWidth > 765 ? "none" : "block" }}
          />
          <Box
            component="form"
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(35%, -50%)",
              width: "16vw",
              height: "35vh",
              backgroundColor: "rgba(255, 255, 255, 85%)",
              p: 3,
              borderRadius: 1,
            }}
            onSubmit={(e) => {
              e.preventDefault(); // 기본 폼 제출 방지
              loginBtn();
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "#0D053D" }}>
              <LockOutlinedIcon />
            </Avatar>
            <TextField
              margin="normal"
              required
              fullWidth
              id="id"
              label="ID"
              name="id"
              autoComplete="id"
              autoFocus
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                e.stopPropagation();
              }}
              sx={{ backgroundColor: "#fff", borderRadius: 1 }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                e.stopPropagation();
              }}
              sx={{ backgroundColor: "#fff", borderRadius: 1 }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: "#003366",
                fontFamily: "Noto Sans KR",
              }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
